import { Button, Text } from '@/components/v4';
import { Box, FormControl, FormLabel, Stack } from '@chakra-ui/react';
import {
    descriptionStyling,
    formLabelStyling,
    stackStyling,
} from 'components/forms/new/formStyles';

function DisassociateTpmNumberBtn({ onOpen, darkMode, isDisabled }) {
    return (
        <FormControl sx={{ margin: '0 !important' }}>
            <Stack
                direction="row"
                sx={{
                    ...stackStyling(true),
                    width: '740px',
                }}>
                <Box width={190}>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Disassociate TPM Number
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Remove association of this TPM number from your
                        organisation. Required before number can be removed
                    </Text>
                </Box>

                <Box
                    display="flex"
                    width={488}
                    alignItems="center"
                    justifyContent="flex-end"
                    marginTop={10}>
                    <Button
                        maxW="142px"
                        colorScheme="red"
                        onClick={onOpen}
                        isDisabled={isDisabled}
                        data-walkthroughid="/numbers/button/disassociate-tpm-number">
                        Disassociate
                    </Button>
                </Box>
            </Stack>
        </FormControl>
    );
}

export default DisassociateTpmNumberBtn;
